import styled from "styled-components";

const CustomIcon = styled.img.attrs((props) => ({
    src: `${process.env.PUBLIC_URL}/icons/icon_${props.iconName}${props.isActive ? "_active" : ""}.png`,
    alt: props.altText || props.iconName,
}))`
    width: ${({ size, width }) => size || width || "18px"};
    height: ${({ size, height }) => size || height || "18px"};
    border-radius: ${({ borderRadius }) => borderRadius || "0px"};
    visibility: ${({ isDisabled }) => (isDisabled ? "hidden" : "visible")};
    cursor: ${({ cursor }) => cursor || "inherit"};
    rotate: ${({ rotate }) => `${rotate}deg` || "0deg"};
`;

export default CustomIcon;
